import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { LOGO_QUERY } from '../../graph/SiteGraph';
import Skeleton from '@mui/material/Skeleton';
import { BASE_API_URL_FLAT  } from 'src/constants';

var _ = require('lodash');

const Logo = (props) => {
  const { theme, size, width, height } = props

  const [getLazyLogo, lazyLogo] = useLazyQuery(LOGO_QUERY, {
    context: { clientName: 'openHttpLink' },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only', // Used for first execution
    nextFetchPolicy: 'cache-first', // Used for subsequent executions
  });

  useEffect(() => {
    getLazyLogo()
  }, [])

  
  if (
    lazyLogo.loading ||
    lazyLogo.data?.logos == null ||
    _.isEmpty(lazyLogo.data?.logos)
  ) return <Skeleton variant={"rectangular"} width={"1.6em"} height={"1.6em"} />;
  if (lazyLogo.error) return (`Error! ${lazyLogo.error}`);

  let reqLogo = lazyLogo.data.logos.filter(option => {
    // console.log(option, theme, size)
    return (option.isActive && option.theme.name == theme && option.size == size)
  })[0]
  // console.log(reqLogo, "this is logo URL ##############")
  //let logoURL = new URL(window.location.origin + reqLogo?.imageFile.url)
  //  const logoURL = new URL(reqLogo.imageFile.url, BASE_API_URL_FLAT);
  //  console.log('logoURL -- > ', logoURL);
  // console.log(logoURL, "this is logo URL ##############")
    var logoURL = BASE_API_URL_FLAT + '/media/images/core/Mars_Global_Profile_Picture_RPqzkNn.png';

  return (
    <img
      alt="Logo"
      src={logoURL}
      width={width ? width : "100%"}
      height={height ? height : "100%"}
      key="toolbar-logo"
    />
  )
  // }
};

export default Logo;
